"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIRTUAL_TRY_ON_PDP = exports.VIRTUAL_TRY_ON = exports.SKIN_DIAGNOSIS = exports.FOUNDATION_FINDER = void 0;
const SKIN_DIAGNOSIS = exports.SKIN_DIAGNOSIS = 'skin-diagnosis';
const FOUNDATION_FINDER = exports.FOUNDATION_FINDER = 'foundation-finder';
const VIRTUAL_TRY_ON = exports.VIRTUAL_TRY_ON = 'virtual-try-on';
const VIRTUAL_TRY_ON_PDP = exports.VIRTUAL_TRY_ON_PDP = 'virtual-try-on-pdp';